export const SET_SHOW_QUOTES_UPDATED = 'SET_SHOW_QUOTES_UPDATED'
export const SET_SHOW_EDIT_SHIPPING_MODAL = 'SET_SHOW_EDIT_SHIPPING_MODAL'
